<template>
  <div class="box6">
    <pageTitle 
      title="大数据技术专家带队<br/>十余年专业云经验助你透彻理解知识点" 
      text="多年云行业相关领域实施经验及授课经验"
      titleColor="#332114"
      titColor=" #664c33"
    />
    <ul class="content teacher-list">
      <li 
        v-for="(item, index) in list"
        :key="index"
        :style="{backgroundImage: `url(${item.url})`}"
        @click="open(index)"
      >
        <div class="teacher-name">{{ item.name }}</div>
        <div class="teacher-tag">{{ item.tag }}</div>
      </li>
    </ul>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
          >
            {{ list[this.cur].tag }}
          </div>
        </div>

        <p
          v-for="(j, index1) in list[this.cur].info"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      show: false,
      cur: 0,
      list:[
        {
          name: '姚老师',
          tag: '阿里云ACE认证持证专家',
          info: [
            '阿里云认证云计算专家（ACE）、澳洲弗林德斯大学教育学硕士。多年开发经验，擅长后端及大数据架构解决方案，深入研究反爬虫机制，采用智能化、策略性的手段规避封锁，确保数据获取的可持续性；在教学上有自己独特教学方式，深受学生喜爱。'
          ],
          url: require('../../../assets/coursePage/acp/box6/pic-0.png')
        },
        {
          name: '王老师',
          tag: '资深大数据开发工程师',
          info: [
            '资深大数据开发工程师、云计算架构师。超10年IT从业经验，曾在多家一线大厂担任技术总监、架构师等职位；精通Java/Python/C++等多种编程语言，精通Hadoop技术栈、千万级离数仓以及云计算平台架构设计；多年大数据开发教学经验，上课诙谐幽默，深受学生喜爱。'
          ],
          url: require('../../../assets/coursePage/acp/box6/pic-1.png')
        },
        {
          name: '赵老师',
          tag: 'ApacheCon Asia 讲师',
          info: [
            '资深大数据技术专家。在Hadoop、SparkTensorflow和PyTorch等大数据领域有多年企业实践经验；主导研发多项国家和省级科研项目，负责企业级信贷风控模型和智能医疗数据平台开发；专注ML/DL/PR/KG领域相关算法应用，曾任职美团搜索部负责NER及Bert搜索排序优化。'
          ],
          url: require('../../../assets/coursePage/acp/box6/pic-2.png')
        },
        {
          name: '原老师',
          tag: '大数据高级工程师',
          info: [
            '北京大学电子与通信工程硕士。曾在多家软件公司担任高级工程师、项目经理；熟悉大数据、机器学习等技术，精通Java、 Python等常用开发语言；多年开发经验，曾主导完成新浪微博，中新网新闻发布系统等多个大型项目。'
          ],
          url: require('../../../assets/coursePage/acp/box6/pic-4.png')
        }
      ]
    }
  },
  methods:{
    open(index){
      this.cur = index
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.box6{
  padding: 76px 0 50px;
  background-image: url(../../../assets/coursePage/acp/box6/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  .teacher-list{
    width: 690px;
    margin: 26px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap:wrap;
    li{
      width: 330px;
	    height: 414px;
      margin-bottom: 30px;
      padding-top: 312px;
      padding-left: 27px;
      box-sizing: border-box;
      background-size: 100% 100%;
      .teacher-name{
        font-family: PingFangSC-Medium;
        font-size: 28px;
        line-height: 28px;
        color: #ffffff;
      }
      .teacher-tag{
        font-family: PingFangSC-Regular;
        font-size: 24px;
        line-height: 24px;
        color: #ffffff;
        margin-top: 15px;
      }
    }
  }
  .pop {
    padding: 48px 48px 58px 48px;
    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
      margin-top: 16px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: rgba(0,230,200, .15);
      border-radius: 8px;
      margin-top: 16px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #00b39b;
    }

    p {
      position: relative;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #ffad00;
        opacity: 0.5;
        transform: rotate(45deg);
      }
    }
  }
}
</style>